import React from 'react';
import ReactDOM from 'react-dom/client';
import {createStore} from 'redux';
import { Provider} from 'react-redux';

import {ScoreBoard} from './score-board.js';

//page
import App from './App.js';
//import reportWebVitals from './reportWebVitals';

//css
import './index.css';
import './App.css';
import './css/Client.css';
import './css/Title.css';
import './css/Login.css';
import './css/Member.css';
import './css/PointRechargeApply.css';
import './css/PointRechargeWait.css';
import './css/Notice.css';
import './css/QAWait.css';
import './css/QAApply.css';
import './css/FAQ.css';
import './css/Guide.css';
import './css/Terms.css';
import './css/DetailModalType1.css';
import './css/DetailModalType2.css';
import './css/DetailModalType3.css';
import './css/WriteModalType.css';


Text.defaultProps = Text.defaultProps || {};
Text.defaultProps.allowFontScaling = false;

function reducer(currentState,action){
  if(currentState===undefined)
    {
      return{
        Request : 0,
        MemberFirstRender : false,
        MemberArray : [],
        RechargeApplyFirstRender : false,
        PointRechargeApplyArray : [],
        RechargeWaitFirstRender : false,
        PointRechargeWaitArray : [],
        NoticeFirstRender : false,
        NoticeArray : [],
        GuideFirstRender : false,
        GuideArray : [],
        TermsFirstRender : false,
        TermsArray : [],
        QAWaitFirstRender : false,
        QAWaitArray : [],
        QAApplyFirstRender : false,
        QAApplyArray : [],
        FAQFirstRender : false,
        FAQArray : [],

        detail_modal_type1_open : false,
        detail_modal_type1_type : 0,
        detail_modal_type1_no : 0,

        detail_modal_type2_open : false,
        detail_modal_type2_no : 0,

        detail_modal_type3_open : false,
        detail_modal_type3_no : 0,

        write_modal_open : false,
        write_type : 0,

        Refresh_FAQ : false,
        Refresh_Guide : false,
        Refresh_Notice : false,
        Refresh_QA_Wait : false,
        Refresh_Terms : false,

        Recommand_Point : 0,
        Register_Point : 0,

        Recharge_Wait_Count : 0,
        QA_Wait_Count : 0,
      }
    }

    const newState = {...currentState};

    if(action.type === 'Request')
    {
        newState.Request = 1;
    }
    
    if(action.type === 'Response')
    {
      newState.Request = 0;
    }

    if(action.type === 'RefreshMemberFirstRender')
    {
      newState.MemberFirstRender = false;
    }

    if(action.type === 'MemberFirstRender')
    {
      newState.MemberFirstRender = true;
    }

    if(action.type === 'RefreshRechargeApplyFirstRender')
    {
      newState.RechargeApplyFirstRender = false;
    }

    if(action.type === 'RechargeApplyFirstRender')
    {
      newState.RechargeApplyFirstRender = true;
    }
    
    if(action.type === 'RefreshRechargeWaitFirstRender')
    {
      newState.RechargeWaitFirstRender = false;
    }

    if(action.type === 'RechargeWaitFirstRender')
    {
      newState.RechargeWaitFirstRender = true;
    }

    if(action.type === 'RefreshRechargeWaitFirstRender')
    {
      newState.RechargeWaitFirstRender = false;
    }

    if(action.type === 'RechargeWaitFirstRender')
    {
      newState.RechargeWaitFirstRender = true;
    }


    if(action.type === 'RefreshNoticeFirstRender')
    {
      newState.NoticeFirstRender = false;
    }

    if(action.type === 'NoticeFirstRender')
    {
      newState.NoticeFirstRender = true;
    }

    if(action.type === 'RefreshGuideFirstRender')
    {
      newState.GuideFirstRender = false;
    }

    if(action.type === 'GuideFirstRender')
    {
      newState.GuideFirstRender = true;
    }

    if(action.type === 'RefreshTermsFirstRender')
    {
      newState.TermsFirstRender = false;
    }

    if(action.type === 'TermsFirstRender')
    {
      newState.TermsFirstRender = true;
    }

    if(action.type === 'RefreshQAWaitFirstRender')
    {
      newState.QAWaitFirstRender = false;
    }

    if(action.type === 'QAWaitFirstRender')
    {
      newState.QAWaitFirstRender = true;
    }

    if(action.type === 'RefreshQAApplyFirstRender')
    {
      newState.QAApplyFirstRender = false;
    }

    if(action.type === 'QAApplyFirstRender')
    {
      newState.QAApplyFirstRender = true;
    }
              
    if(action.type === 'RefreshFAQFirstRender')
    {
      newState.FAQFirstRender = false;
    }

    if(action.type === 'FAQFirstRender')
    {
      newState.FAQFirstRender = true;
    }          

    if(action.type === 'UpdateMemberArray')
    {
      newState.MemberArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdatePointRechargeApplyArray')
    {
      newState.PointRechargeApplyArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdatePointRechargeWaitArray')
    {
      newState.PointRechargeWaitArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateNoticeArray')
    {
      newState.NoticeArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateGuideArray')
    {
      newState.GuideArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateTermsArray')
    {
      newState.TermsArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateQAWaitArray')
    {
      newState.QAWaitArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateQAApplyArray')
    {
      newState.QAApplyArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateFAQArray')
    {
      newState.FAQArray = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateDetailModalType1')
    {
      newState.detail_modal_type1_open = action.View;
      newState.detail_modal_type1_type = action.Type;
      newState.detail_modal_type1_no = action.No;
    }     

    if(action.type === 'UpdateDetailModalType2')
    {
      newState.detail_modal_type2_open = action.View;
      newState.detail_modal_type2_no = action.No;
    } 

    if(action.type === 'UpdateDetailModalType3')
    {
      newState.detail_modal_type3_open = action.View;
      newState.detail_modal_type3_no = action.No;
    } 

    if(action.type === 'UpdateWriteModal')
    {
      newState.write_modal_open = action.View;
      newState.write_type = action.Type;
    } 

    if(action.type === 'RefreshFAQ')
    {
      newState.Refresh_FAQ = action.Refresh;
    } 
    
    if(action.type === 'RefreshGuide')
    {
      newState.Refresh_Guide = action.Refresh;
    } 
     
    if(action.type === 'RefreshNotice')
    {
      newState.Refresh_Notice = action.Refresh;
    } 

    if(action.type === 'RefreshQAWait')
    {
      newState.Refresh_QA_Wait = action.Refresh;
    } 

    if(action.type === 'RefreshTerms')
    {
      newState.Refresh_Terms = action.Refresh;
    } 

    if(action.type === 'UpdateRecommandPoint')
    {
      newState.Recommand_Point = action.Value;
    } 

    if(action.type === 'UpdateRegisterPoint')
    {
      newState.Register_Point = action.Value;
    } 

    if(action.type === 'UpdateRechargeWaitCount')
    {
      newState.Recharge_Wait_Count = action.count;
    } 

    if(action.type === 'UpdateQAWaitCount')
    {
      newState.QA_Wait_Count = action.count;
    } 

    return newState;
}

const store = createStore(reducer);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App this={root._internalRoot.containerInfo.style}/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
